<template>
  <megabit-base-dialog :show-dialog="true" fullscreen class="gray">
    <template v-slot:body>
      <v-app-bar flat dense app :dark="!switchTheme" style="left: 50px">
        <v-switch
          v-model="switchTheme"
          :label="`Tema ${!switchTheme ? 'Escuro' : 'Claro'}`"
          class="mt-5"
          id="theme"
        ></v-switch>
        <v-spacer></v-spacer>
        <v-toolbar-title>
          Gerenciador de Pedidos
          <!-- {{ lastUpdate ? `[${lastUpdate}]` : '' }} -->
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <div v-if="statusMerchant && statusMerchant[0]" class="mr-12">
          <v-btn
            v-if="statusMerchant[0].state == 'OK'"
            class="red darken-4 mr-2 white--text"
            outlined
            :loading="loader"
            :disabled="loader"
            @click.stop="closeDialogCloseRestaurant()"
          >
            {{ merchantButtonAction }}
          </v-btn>
          <v-btn
            v-else
            :loading="loader"
            :disabled="loader"
            class="grey mr-2 white--text"
            outlined
            @click.prevent="disableInterruption()"
          >
            {{ merchantButtonAction }}
          </v-btn>
          <v-dialog
            v-model="dialogCloseRestaurant"
            max-width="500px"
            transition="dialog-bottom-transition"
          >
            <v-card :dark="!switchTheme">
              <v-card-title>
                <span class="headline">Fechar o Restaurante agora</span>
              </v-card-title>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <div>
                      Fechar seu restaurante temporariamente e ganhe tempo para
                      preparar os pedidos que já recebeu. Você reabre
                      automaticamente quando o tempo acabar.
                    </div>
                    <v-col>
                      <v-radio-group v-model="optionTime">
                        <template v-slot:label> </template>
                        <v-radio
                          v-for="option in optionsTimeToClose"
                          :key="option.id"
                          :label="option.title"
                          :value="option.value"
                          dense
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col>
                      <v-radio-group v-model="optionReason">
                        <template v-slot:label> </template>
                        <v-radio
                          v-for="option in optionsReasonToClose"
                          :key="option.id"
                          :label="option.title"
                          :value="option.id"
                          dense
                          @click="reasonDescription = null"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row v-if="optionReason && optionReason == 4">
                    <v-textarea
                      label="Qual Motivo? (Opcional)"
                      placeholder="Ex. Já vendi muito hoje e estou satisfeito"
                      outlined
                      v-model="reasonDescription"
                    >
                    </v-textarea>
                  </v-row>
                </v-container>
              </v-card-text>
              <form-buttons
                @goBack="closeDialogCloseRestaurant()"
                @submitForm="submitDialogCloseRestaurant()"
              />
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogStatusRestaurant"
            max-width="450px"
            transition="dialog-bottom-transition"
            content-class="my-custom-dialog"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-3"
                :class="merchantStyles.color"
                v-bind="attrs"
                v-on="on"
                :loading="loaderStatusIsComming"
              >
                <v-icon :color="merchantStyles.iconColor" left>
                  {{ merchantStyles.icon }}
                </v-icon>
                {{
                  statusMerchant[0].message
                    ? statusMerchant[0].message.title
                    : ''
                }}
              </v-btn>
            </template>
            <v-card :dark="!switchTheme">
              <v-card-title class="text-h5 font-weight-bold">
                Status da Loja
                <v-spacer></v-spacer>
                <v-btn icon color="red" @click="dialogStatusRestaurant = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <div v-if="statusMerchant[0].validations">
                <v-container>
                  <div
                    v-for="(validation, index) in statusMerchant[0].validations"
                    :key="index"
                  >
                    <div v-if="statusMerchant[0].state != 'OK' && index == 0">
                      <v-card-text>
                        <v-container fluid>
                          <v-card elevation="1">
                            <v-card-title class="flex-grow-1 flex-shrink-1">
                              <v-icon left>mdi-clock-outline</v-icon>
                              {{ validation.message.title }}
                              <p
                                class="text-subtitle-1 ml-8"
                                v-if="validation.message.subtitle"
                              >
                                {{ validation.message.subtitle }}
                              </p>
                              <p class="text-subtitle-1 ml-8">
                                {{ validation.message.description }}
                              </p>
                            </v-card-title>
                          </v-card>
                        </v-container>
                      </v-card-text>
                    </div>
                    <v-card-title v-else>
                      <v-icon color="success" left>mdi-check-bold</v-icon>
                      {{ validation.message.title }}
                      <span
                        class="text-subtitle-1 ml-8"
                        v-if="validation.message.subtitle"
                      >
                        {{ validation.message.subtitle }}
                      </span>
                      <p class="text-subtitle-1 ml-8">
                        {{ validation.message.description }}
                      </p>
                    </v-card-title>
                  </div>
                  <v-divider></v-divider>
                  <span
                    class="d-flex flex-justify-content text-subtitle-1 font-weight-bold pa-2"
                  >
                    Essa informação pode levar até 1 minuto para atualizar
                    depois de ser alterada.
                  </span>
                </v-container>
              </div>
            </v-card>
          </v-dialog>
        </div>
      </v-app-bar>
      <v-navigation-drawer
        v-model="drawer"
        :mini-variant.sync="mini1"
        :mini-variant-width="50"
        :permanent="true"
        height="100vh"
        max-width="50"
        :dark="!switchTheme"
        fixed
      >
        <v-list dense>
          <v-list-item link @click="closeGerenciador">
            <v-list-item-icon>
              <v-icon>mdi-close</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t('labels.fechar') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="(item, index) in dialogButtons" :key="index" link>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="openSynchronizationLog()">
            <v-list-item-icon>
              <v-icon>mdi-format-list-bulleted</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Log</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-card max-height="100vh" :dark="!switchTheme">
        <v-main class="gray" style="padding: 48px 0px 0px 55px;">
          <v-tabs v-model="tabInicio" :dark="!switchTheme">
            <v-tab>Gestão</v-tab>
            <v-tab>
              {{ $t('ifood.agora') }}
              <v-badge
                :content="nowCanceledCounter"
                :value="nowCanceledCounter > 0"
                color="red lighten-1"
                overlap
                class="pl-3 pt-8"
                bordered
                left
              >
              </v-badge>
              <v-badge
                :content="nowCounter"
                :value="nowCounter > 0"
                color="green lighten-1"
                bordered
              >
              </v-badge>
            </v-tab>
            <v-tab>
              {{ $t('ifood.agendado') }}
              <v-badge
                :content="scheduledCanceledCounter"
                :value="scheduledCanceledCounter > 0"
                color="red lighten-1"
                overlap
                class="pl-3 pt-8"
                bordered
                left
              >
              </v-badge>
              <v-badge
                :content="scheduledCounter"
                :value="scheduledCounter > 0"
                color="green lighten-1"
                bordered
              >
              </v-badge>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabInicio" :dark="!switchTheme">
            <v-tab-item class="p-3">
              <v-row dense>
                <v-col xs="12" sm="4" md="4" class="d-sm-inline-block">
                  <v-row dense>
                    <v-col
                      xs="12"
                      sm="12"
                      md="6"
                      lg="6"
                      xl="6"
                      class="d-sm-inline-block"
                    >
                      <c-input
                        class="ml-2"
                        :label="'Nº Pedido'"
                        :placeholder="'Nº Pedido'"
                        :maxLength="8"
                        :dark="!switchTheme"
                        v-model="filter.text"
                        clearable
                      />
                    </v-col>
                    <v-col
                      xs="12"
                      sm="12"
                      md="6"
                      lg="6"
                      xl="6"
                      class="d-sm-inline-block"
                    >
                      <c-select-multiple
                        class="ml-2"
                        itemText="title"
                        itemValue="value"
                        :lista="filters"
                        :rotulo="'Filtros'"
                        :size="filter.selectedFilters.length"
                        :item.sync="filter.selectedFilters"
                        v-model="filter.selectedFilters"
                        :dark="!switchTheme"
                      >
                        >
                      </c-select-multiple>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <v-card class="ml-2">
                        <v-toolbar>
                          <v-toolbar-title
                            >Pedidos Gestão
                            <span class="text-caption">
                              {{
                                orderListComputed.length > 0
                                  ? '(' +
                                    orderListComputed.length +
                                    ' pedidos) '
                                  : ''
                              }}
                            </span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon @click="getOrdersGestao">mdi-refresh</v-icon>
                        </v-toolbar>
                        <v-progress-linear
                          indeterminate
                          color="rgba(241, 0, 0, 0.7)"
                          :active="loadingOrder"
                        />
                        <v-divider />
                        <v-card class="scroll" :max-height="cardItemHeight">
                          <div
                            v-for="(order, index) in orderListComputed"
                            :key="index"
                            class="pt-2"
                          >
                            <v-card
                              light
                              :class="
                                selectedCard == order.NUMEROEXPORTADO
                                  ? 'card-selected'
                                  : ''
                              "
                              class="mx-2 elevation-2"
                              hover
                            >
                              <v-card-text
                                style="position: relative"
                                @click="selectOrder(order)"
                              >
                                <div class="d-flex justify-space-between">
                                  <div class="ml-0">
                                    <div class="mt-2">
                                      <v-chip small>
                                        {{
                                          order.DATA
                                            ? new Date(
                                                order.DATA + '-03:00'
                                              ).toLocaleDateString('pt-BR')
                                            : null
                                        }}
                                        {{ order.HORA }}
                                      </v-chip>
                                    </div>
                                    <div class="mt-2">
                                      <v-chip small>
                                        <v-icon left color="red">
                                          {{
                                            getTipoPrevisaoEntrega(
                                              order.TIPOPREVISAOENTREGA
                                            ).icon
                                          }}
                                        </v-icon>
                                        {{
                                          getTipoPrevisaoEntrega(
                                            order.TIPOPREVISAOENTREGA
                                          ).title
                                        }}
                                      </v-chip>
                                    </div>
                                    <div class="mt-2">
                                      <v-chip small class="red white--text">
                                        {{
                                          order.GERADOPELAROTINA.split('_')[1]
                                        }}
                                      </v-chip>
                                    </div>
                                  </div>
                                  <div>
                                    <div class="font-weight-bold black--text">
                                      <span
                                        class="text-h6 font-weight-bold red--text"
                                      >
                                        #{{ order.NUMEROEXPORTADO }}
                                      </span>
                                    </div>
                                    <v-chip
                                      small
                                      :class="
                                        getInfoChipLiberado(order).className
                                      "
                                    >
                                      {{ getInfoChipLiberado(order).text }}
                                    </v-chip>
                                    <div>
                                      <v-chip
                                        v-if="order.NUMERONOTA"
                                        small
                                        class="mt-2 font-weight-bold"
                                      >
                                        NFE: {{ order.NUMERONOTA }}
                                      </v-chip>
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                              <template>
                                <v-fab-transition>
                                  <v-btn
                                    color="red darken-1"
                                    dark
                                    absolute
                                    bottom
                                    right
                                    fab
                                    class="mb-9 "
                                    height="30"
                                    width="30"
                                    @click="showDetails(order)"
                                  >
                                    <v-img
                                      contain
                                      height="16"
                                      src="/images/logo_integracoes/ifood-black.ico"
                                    ></v-img>
                                  </v-btn>
                                </v-fab-transition>
                              </template>
                            </v-card>
                          </div>
                        </v-card>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col v-if="selectedOrder && selectedOrder.error">
                  <v-card>
                    <h1>
                      {{
                        `${selectedOrder.gestao.TIPO} Gestão # ${selectedOrder.gestao.NUMERO}`
                      }}
                    </h1>
                    <v-card-title>
                      {{ selectedOrder.error }}
                    </v-card-title>
                  </v-card>
                </v-col>
                <v-col v-else xs="12" sm="8" md="8" class="gray">
                  <OrderDetailsGestao
                    :selectedOrder="selectedOrder"
                    v-if="selectedOrder && !showDetailsOrder"
                  ></OrderDetailsGestao>
                  <OrderDetails v-else-if="showDetailsOrder"></OrderDetails>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-col cols="12">
                <OrderList
                  :switchTheme="switchTheme"
                  :pollingList="nowPollingList"
                />
              </v-col>
            </v-tab-item>
            <v-tab-item>
              <v-col cols="12">
                <OrderList
                  :switchTheme="switchTheme"
                  :pollingList="scheduledPollingList"
                />
              </v-col>
            </v-tab-item>
          </v-tabs-items>
        </v-main>
      </v-card>
      <confirm :persistent="true" ref="confirm" v-model="confirm"></confirm>
      <synchronization-log
        v-if="dialogs.showSynchronizationLogDialog"
        :showDialog="dialogs.showSynchronizationLogDialog"
        @goBack="dialogs.showSynchronizationLogDialog = false"
        :synchronizationLog="synchronizationLog"
        :getLogs="getLogs"
        :setEmptyLog="setEmptyLog"
      />
    </template>
  </megabit-base-dialog>
</template>

<script>
import OrderList from '@/views/integration/ifood/OrderList/OrderList'
import OrderDetailsGestao from '@/views/integration/ifood/OrderList/OrderDetailsGestao'
import OrderDetails from './OrderList/OrderDetails'
import MegabitBaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelectMultiple from '@/components/shared/base-input/BaseSelectMultiple.vue'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import Confirm from '@/components/shared/base-dialog/Confirm.vue'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { ifoodMixin } from '@/mixins/object/integration/iFood/IfoodMixin'

import { mapActions, mapState, mapGetters } from 'vuex'

// import soundIfoodOrder from '@/assets/sounds_integracoes/vinheta-ifood.wav'
import soundIfoodOrder from '@/assets/sounds_integracoes/telephone-ring.mp3'

export default {
  name: 'FormGerenciadorIfood',
  mixins: [currencyMixin, ifoodMixin],
  components: {
    MegabitBaseDialog,
    OrderList,
    cInput,
    // cSelect,
    cSelectMultiple,
    FormButtons,
    Confirm,
    OrderDetailsGestao,
    OrderDetails,
    SynchronizationLog: () =>
      import('@/components/unique/integration/SynchronizationLog'),
  },
  data: () => ({
    dialogs: {
      showSynchronizationLogDialog: false,
    },
    lastUpdate: null,
    merchantId: null,
    switchTheme: false,
    confirm: false,
    loader: false,
    loaderStatusIsComming: false,
    dialog: true,
    drawer: true,
    dialogOptionsCancelOrder: false,
    dialogCancelOrderValid: false,
    optionCancelOrder: null,
    loadingOrder: false,
    showDetailsOrder: false,
    dialogButtons: [
      { title: 'Início', icon: 'mdi-home' },
      { title: 'Cardápio', icon: 'mdi-bookshelf' },
    ],
    selectedOrder: null,
    selectedCard: null,
    mini: true,
    tabInicio: 0,
    filter: {
      text: '',
      selectedFilters: [],
    },
    filters: [
      { title: 'Pendente', value: 'P' },
      { title: 'Liberado', value: 'S' },
      { title: 'Pré-Liberado', value: 'PS' },
      { title: 'Cancelado', value: 'C' },
    ],
    itemsTipoPrevisao: [
      { title: 'Retira', value: 'R', icon: 'mdi-store' },
      { title: 'Entrega', value: 'E', icon: 'mdi-moped-outline' },
      {
        title: 'Agendada',
        value: 'F',
        icon: 'mdi-calendar-clock',
      },
    ],

    ifoodOrderList: [],

    dialogCloseRestaurant: false,
    dialogStatusRestaurant: false,
    optionTime: 15,
    optionReason: 4,
    reasonDescription: null,
    fullscreenItem: {
      xs: '100vh',
      sm: '48vh',
      md: '48vh',
      lg: '58vh',
      xl: '72vh',
    },
  }),
  computed: {
    ...mapState('authModule', ['authUser']),
    ...mapState('systemModule', ['currentSystem']),
    ...mapState('ifoodModule', [
      'statusMerchant',
      'orderList',
      'orderPolling',
      'optionsToCancelOrder',
      'optionsTimeToClose',
      'optionsReasonToClose',
    ]),
    ...mapGetters({
      nowPollingList: 'ifoodModule/nowPollingList',
      scheduledPollingList: 'ifoodModule/scheduledPollingList',
      synchronizationLog: 'ifoodModule/getSynchronizationLog',
    }),

    placedOrders() {
      return this.nowPollingList.filter((event) => event.code == 'PLC')
    },
    cardItemHeight() {
      return this.fullscreenItem[this.$vuetify.breakpoint.name]
    },
    nowCanceledCounter() {
      return this.nowPollingList.filter(
        (v) => this.canceledCodes.lastIndexOf(v.code) != -1
      ).length
    },
    nowCounter() {
      return this.nowPollingList.filter(
        (v) => this.canceledCodes.lastIndexOf(v.code) == -1
      ).length
    },
    scheduledCanceledCounter() {
      return this.scheduledPollingList.filter(
        (v) => this.canceledCodes.lastIndexOf(v.code) != -1
      ).length
    },
    scheduledCounter() {
      return this.scheduledPollingList.filter(
        (v) => this.canceledCodes.lastIndexOf(v.code) == -1
      ).length
    },
    mini1: {
      get() {
        return true
      },
      set() {
        this.mini = true
      },
    },
    orderListComputed() {
      let search = this.filter.text
      let selectedsFilters = this.filter.selectedFilters

      let r = this.orderList
      if (search && search.length > 0) {
        r = r.filter((v) => v.NUMEROEXPORTADO.toString().indexOf(search) !== -1)
      }

      if (selectedsFilters.length > 0) {
        r = r.filter((order) => {
          const f = selectedsFilters.filter((f) => {
            if (f.value == 'PS')
              return order.LIBERADO == 'P' && order.PRELIBERADO == 'S'
            return order.LIBERADO != 'P'
              ? f.value == order.LIBERADO
              : f.value == order.LIBERADO && order.PRELIBERADO != 'S'
          })
          return f.length > 0 ? true : false
        })
      }
      return r
    },
    merchantButtonAction() {
      return this.statusMerchant[0] && this.statusMerchant[0].state != 'OK'
        ? this.$t('ifood.abrirLoja')
        : this.$t('ifood.fecharLoja')
    },

    merchantStyles() {
      let color = ''
      let icon = ''
      let iconColor = 'red'

      if (this.statusMerchant[0])
        switch (this.statusMerchant[0].state) {
          case 'WARNING':
            color = 'yellow'
            icon = 'mdi-alert-outline'
            break
          case 'CLOSED':
            color = 'grey'
            icon = 'mdi-cancel'
            break
          case 'ERROR':
            color = 'red'
            icon = 'mdi-alert-circle'
            iconColor = 'white'
            break

          default:
            color = 'success'
            icon = 'mdi-check-circle'
            iconColor = 'white'
            break
        }

      return { color, icon, iconColor }
    },
  },
  async mounted() {
    try {
      if (this.$route.params.id) {
        this.merchantId = this.$route.params.id
        localStorage.setItem('merchant', JSON.stringify(this.$route.params))
      } else {
        const merchant = JSON.parse(localStorage.getItem('merchant'))
        this.merchantId = merchant.id
      }

      this.startListen()
      // para indicar que o status ainda não veio
      this.loaderStatusIsComming = true

      await this.getStatusMerchant()
      await this.getOrdersGestao()
    } catch (error) {
      this.$toasted.error(error, { duration: null })
    }
  },
  watch: {
    tabInicio(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setOrderPolling(null)
      }
    },
  },
  methods: {
    ...mapActions({
      setPollingList: 'ifoodModule/setPollingList',
      setOrderPolling: 'ifoodModule/setOrderPolling',
      getStatusMerchant: 'ifoodModule/getStatusMerchant',
      setStatusMerchant: 'ifoodModule/setStatusWebsocket',
      getOrdersIntegration: 'ifoodModule/getOrdersIntegration',
      getOrderIntegration: 'ifoodModule/getOrderIntegration',
      createInterruption: 'ifoodModule/createInterruption',
      deleteInterruption: 'ifoodModule/deleteInterruption',
      setLoadingMessage: 'dialogModule/setLoadingDialogMessage',
      setLoadingShow: 'dialogModule/setShowLoadingDialog',

      getLogs: 'ifoodModule/getSynchronizationLog',
      setEmptyLog: 'ifoodModule/setEmptySynchronizationLog',
    }),

    openSynchronizationLog() {
      this.dialogs.showSynchronizationLogDialog = true
    },

    async showDetails(order) {
      try {
        this.setLoadingShow(true)
        this.setLoadingMessage(`Buscando pedido ${order.NUMEROEXPORTADO}`)
        await this.searchOrder(order)
        this.showDetailsOrder = true
      } finally {
        this.setLoadingShow(false)
      }
    },
    async getOrdersGestao() {
      try {
        this.loadingOrder = true
        const fullDate = new Date()
        const currentDate = `${fullDate.getFullYear()}-${this.padLeftZero(
          fullDate.getMonth() + 1
        )}-${this.padLeftZero(fullDate.getDate())}`

        const query = {
          DATAINI: currentDate,
          DATAFIM: currentDate,
          LAST: 'S',
        }
        await this.getOrdersIntegration(query)

        if (this.orderList && this.orderList.length < 1)
          this.$toasted.success('Nenhum pedido encontrado!', { duration: 3000 })
      } finally {
        this.loadingOrder = false
      }
    },
    padLeftZero(n) {
      return n > 9 ? n : '0' + n
    },
    async searchOrder(order) {
      const orderID =
        order && order.IDPDA ? order.IDPDA.split('_Balcao_Ifood')[0] : ''
      await this.getOrderIntegration(orderID)
    },
    goBack() {
      this.dialog = false
      this.$router.back()
    },

    async disableInterruption() {
      try {
        this.loader = !this.loader

        if (!this.statusMerchant[0]) {
          this.$toasted.error('Status Merchant não encontrado', {
            duration: 5000,
          })
          return
        } else if (!this.statusMerchant[0].reopenable.reopenable) {
          this.$toasted.error(
            'Solicitação não permitida. Verifique regras Portal iFood!',
            {
              duration: 5000,
            }
          )
          return
        } else if (!this.statusMerchant[0].reopenable.identifier) {
          this.$toasted.error(
            'Identificador Ifood não encontrado.\r\n Chamar atendimento iFood para reabertura da loja!',
            {
              duration: 5000,
            }
          )
          return
        } else {
          this.loader = true

          const response = await this.deleteInterruption({
            id: this.statusMerchant[0].reopenable.identifier,
          })

          if (response)
            this.$toasted.success(
              'O Agendamento de Pedidos foi retomado com sucesso!',
              { duration: 3000 }
            )
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.loader = !this.loader
      }
    },

    getMerchantStyles() {
      let color = ''
      let icon = ''
      let iconColor = 'red'

      if (this.statusMerchant[0])
        switch (this.statusMerchant[0].state) {
          case 'WARNING':
            color = 'yellow'
            icon = 'mdi-alert-outline'
            break
          case 'CLOSED':
            color = 'grey'
            icon = 'mdi-cancel'
            break
          case 'ERROR':
            color = 'red'
            icon = 'mdi-alert-circle'
            iconColor = 'white'
            break

          default:
            color = 'success'
            icon = 'mdi-check-circle'
            iconColor = 'white'
            break
        }

      return { color, icon, iconColor }
    },
    getInfoChipLiberado(order) {
      let obj = {}
      if (order.LIBERADO == 'S')
        obj = { text: 'Liberado', className: 'green white--text' }
      else if (order.PRELIBERADO == 'S')
        obj = { text: 'Pré-Liberado', className: 'warning white--text' }
      else if (order.LIBERADO == 'C')
        obj = { text: 'Cancelado', className: 'red white--text' }
      else if (order.LIBERADO == 'P')
        obj = { text: 'Pendente', className: 'info white--text' }

      return obj
    },
    async submitDialogCloseRestaurant() {
      try {
        this.loader = true
        if (!this.optionTime || !this.optionReason) {
          this.$toasted.error('Selecione as opções para continuar!', {
            duration: 3000,
          })
        }

        if (!this.optionTime || !this.optionReason) {
          this.$toasted.error('Selecione as opções para continuar!', {
            duration: 3000,
          })
        }

        const optionTime = this.optionsTimeToClose.filter(
          (option) => option.value == this.optionTime
        )[0]

        const optionReason =
          this.reasonDescription ??
          this.optionsReasonToClose.filter(
            (option) => option.id == this.optionReason
          )[0].title

        if (
          await this.$refs.confirm.open(
            this.$i18n.t('labels.confirmar'),
            this.$i18n.t('dialogs.actions', {
              action: this.$i18n.t('labels.confirmar'),
              nome: this.$t('ifood.fechamentoLoja'),
              codigo: `${optionTime.title} / ${optionReason ?? ''}`,
            }),
            { color: 'red' }
          )
        ) {
          const payload = {
            reason: optionReason,
            time: optionTime.value,
          }
          this.closeDialogCloseRestaurant()
          const response = await this.createInterruption(payload)

          if (response)
            this.$toasted.success(
              'O Agendamento de Pedidos foi pausado com sucesso!',
              { duration: 3000 }
            )
        } else {
          return
        }
      } catch (error) {
        this.$toasted.error(error, { duration: 5000 })
      } finally {
        this.loader = !this.loader
      }
    },
    closeDialogCloseRestaurant() {
      this.dialogCloseRestaurant = !this.dialogCloseRestaurant
    },

    getTipoPrevisaoEntrega(value) {
      return this.itemsTipoPrevisao.filter((v) => v.value == value)[0]
    },
    async selectOrder(order) {
      try {
        this.loadingOrder = true
        this.showDetailsOrder = false
        this.mini = true

        this.selectedCard = order.NUMEROEXPORTADO

        this.selectedOrder = {
          ...order,
        }
      } finally {
        this.loadingOrder = false
      }
    },

    async showNotification(qty, type = null) {
      if (Notification.permission !== 'granted') {
        // Pede ao usuário para utilizar a Notificação Desktop
        // Let's check if the browser supports notifications
        if (!('Notification' in window)) {
          console.log('This browser does not support notifications.')
        } else {
          await Notification.requestPermission()
        }
      }

      var notification = new Notification('IFOOD', {
        lang: 'pt-BR',
        tag: 'ifood-notify-order',
        renotify: true,
        icon: '/images/logo_integracoes/logo_ifood.png',
        body: `${qty} Pedido ${type} Recebido!`,
      })

      //Executa som IFOOD novo Pedido
      if (soundIfoodOrder) {
        // verificar se o audio pode ser executado
        const ctx = new (window.AudioContext || window.webkitAudioContext)()
        const osc = ctx.createOscillator()
        osc.connect(ctx.destination)

        if (ctx.state == 'running') {
          const music = new Audio(soundIfoodOrder)
          await music.play()
        } else
          this.$toasted.info(
            'Não foi possivel emitir aviso sonoro. \r\nVerificar permissão "Som" do Navegador ou clique em qualquer ponto da tela.',
            { duration: 5000 }
          )
      }

      notification.onclick = function() {
        let currentUrl = window.location.href
        window.open(currentUrl)
      }
    },
    async startListen() {
      await this.stopListen()

      try {
        /**
         * Vai ouvir canal com o IDMERCHANT da integração
         * ifood.e200ce1c-1cba-4268-8506-5dbbf9abfafa
         */
        this.userChannel = `ifood.${this.merchantId}`
        console.log('vou começar ouvir', this.userChannel)

        window.Echo.channel(this.userChannel).listen(
          '.IfoodStatus',
          async (e) => {
            try {
              this.loaderStatusIsComming = true
              await this.setStatusMerchant(e.data.original)
            } finally {
              this.loaderStatusIsComming = !this.loaderStatusIsComming
            }
          }
        )

        window.Echo.channel(this.userChannel).listen(
          '.IfoodPolling',
          async (e) => {
            const date = new Date()

            const result = JSON.parse(e.data)

            await this.setPollingList(result)

            if (result.original !== {} && Array.isArray(result.original)) {
              this.lastUpdate =
                date.toLocaleDateString('pt-BR') +
                ' ' +
                date.toLocaleTimeString('pt-BR')
              let canceled = result.original.filter(
                (event) => this.canceledCodes.lastIndexOf(event.code) != -1
              )
              if (canceled.length > 0) {
                // this.showNotification(canceled.length, 'CANCELADO')
                this.$toasted.error(
                  `Pedido Cancelado! ${canceled[0].metadata.CANCEL_REASON}`,
                  { duration: 5000 }
                )
              }

              if (this.placedOrders.length > 0)
                this.showNotification(this.placedOrders.length, 'NOVO')
            }
          }
        )
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async stopListen() {
      if (this.userChannel) {
        await window.Echo.leaveChannel(this.userChannel)
        this.userChannel = null
      }
    },
    async closeGerenciador() {
      this.$router.push({ name: 'Integracao.ifood' })
    },
  },
}
</script>

<style>
.card-selected {
  border: 2px solid red !important;
}

.scroll {
  overflow-y: scroll;
}

.card {
  display: flex !important;
  flex-direction: column;
}

.card-text {
  flex-grow: 1;
  overflow: auto;
}

.my-custom-dialog {
  position: absolute;
  right: 0;
  top: 5%;
}
</style>
